import type { CohortRole } from "types"

export type CohortRoleLabelSource = {
  mentee_label_singular?: string | null
  mentee_label_plural?: string | null
  mentor_label_singular?: string | null
  mentor_label_plural?: string | null
} | null | undefined

export type CohortRoleLabels = {
  menteeSingular: string
  menteePlural: string
  mentorSingular: string
  mentorPlural: string
}

export const DEFAULT_COHORT_ROLE_LABELS: CohortRoleLabels = {
  menteeSingular: "Scholar",
  menteePlural: "Scholars",
  mentorSingular: "Mentor",
  mentorPlural: "Mentors",
}

const clean = (value: string | null | undefined, fallback: string) => {
  const trimmed = typeof value === "string" ? value.trim() : ""
  return trimmed || fallback
}

export const getCohortRoleLabels = (source?: CohortRoleLabelSource): CohortRoleLabels => ({
  menteeSingular: clean(source?.mentee_label_singular, DEFAULT_COHORT_ROLE_LABELS.menteeSingular),
  menteePlural: clean(source?.mentee_label_plural, DEFAULT_COHORT_ROLE_LABELS.menteePlural),
  mentorSingular: clean(source?.mentor_label_singular, DEFAULT_COHORT_ROLE_LABELS.mentorSingular),
  mentorPlural: clean(source?.mentor_label_plural, DEFAULT_COHORT_ROLE_LABELS.mentorPlural),
})

export const getCohortRoleLabel = (
  role: CohortRole | string | null | undefined,
  source?: CohortRoleLabelSource,
) => {
  const labels = getCohortRoleLabels(source)
  switch (role) {
    case "mentor":
      return labels.mentorSingular
    case "mentee":
      return labels.menteeSingular
    case "cohort_director":
      return "Cohort Director"
    case "cohort_admin":
      return "Cohort Admin"
    default:
      return labels.menteeSingular
  }
}

export const getInviteeBucketLabel = (
  bucket: "mentors" | "scholars",
  source?: CohortRoleLabelSource,
) => {
  const labels = getCohortRoleLabels(source)
  return bucket === "mentors" ? labels.mentorPlural : labels.menteePlural
}

export const lowerLabel = (label: string) => label.toLocaleLowerCase()
